import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./filter";
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]));
import bus from "./bus";
Vue.prototype.bus = bus;
// import 'lib-flexible'
//elemetUi
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
//axios
import api from "./api/api";
Vue.prototype.$api = api;
//全局函数
import globel from "./globel";
Vue.prototype.$globel = globel;
Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
  const href = window.location.href
  if (href.indexOf('/?code') > -1) {
    const urlArr = href.split('/?')
    const leftUrl = urlArr[0] + '/#/'
    const rightUrlArr = urlArr[1].split('#/')
    const queryObj = {}
    // 获取code和state参数
    rightUrlArr[0]
      .split('&')
      .map((item) => {
        const splitStr = item.split('=')
        return {
          key: splitStr[0],
          value: splitStr[1],
        }
      })
      .forEach((item) => {
        queryObj[item.key] = item.value
      })
    location.href = leftUrl + rightUrlArr[1] + '?' + rightUrlArr[0]
  } else {
    if (to.path == "/login" || to.path == "/ssoLogin" || to.path == "/register" || to.path == '/wwLogin' || to.path == '/relogin') {
      next();
    } else if (sessionStorage.getItem("access_token")) {
      next();
    } else {
      sessionStorage.removeItem("access_token");
      Vue.prototype.$message({
        message: "您没有登录请登录",
        type: "warning",
      });
      next({
        path: "/ssoLogin", //待在此页面
      });
    }
  }


});



new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

